import React, { useState, useEffect } from 'react'
import MasterPage from 'components/MasterPage'
import ListingReportsFunds from 'components/ListingReportsFunds'
import { api } from 'services'
import { Row, Col, Card, Table, Button, Spinner } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { DashboardOutlined } from '@material-ui/icons'
import convertToAscii from 'helpers/ConvertToASCII'
import ReactDOMServer from 'react-dom/server'

const ReportFunds = () => {
  const defaultFilters = {
    search: '',
    per_page: 10,
    page: 1,
    fiscal_year: ''
  };
  const { t } = useTranslation()
  const [filters, setFilters] = useState(defaultFilters)
  const [funds, setFunds] = useState([])
  const [pagination, setPagination] = useState({})
  const [fiscalYears, setFiscalYears] = useState([])
  const [load, setLoad] = useState(true)
  const [isExport, setIsExport] = useState(false)

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters }
    if (reset) f = { ...defaultFilters, ...new_filters }
    setFilters(f);
  };

  const colConfig = {
    headerStyle: {
      width: '4%',
      textAlign: 'center'
    },
    style: {
      textAlign: 'center',
      fontSize: '15px'
    }
  }

  const columns = [
    {
      dataField: 'manufacturer',
      text: 'Fabricante',
      ...colConfig
    },
    {
      dataField: 'real_value',
      text: 'Valor Real',
      ...colConfig
    },
    {
      dataField: 'period',
      text: 'Período',
      ...colConfig
    },
    {
      dataField: 'action_name',
      text: 'Nome da Ação',
      ...colConfig
    },
    {
      dataField: 'action_id',
      text: 'Id da Ação',
      ...colConfig
    },
    {
      dataField: 'action_value',
      text: 'Valor da Ação',
      ...colConfig
    },
    {
      dataField: 'balance',
      text: 'Saldo',
      ...colConfig
    }
  ];


  useEffect(() => {
    getFunds()
    getFiscalYears()

  }, [filters])

  const getFunds = async () => {
    const response = await fetchFunds(filters)
    const { data, from, to, total, current_page, per_page } = response.data
    setFunds(formatData(data))
    setPagination({ from, to, total, current_page, per_page })
  }

  const getFiscalYears = async () => {
    const response = await fetchFiscalYears()
    const { data } = response
    //setFilters({...filters, fiscal_year: data[0].fiscal_year})
    setFiscalYears(data.map(({ fiscal_year }) => fiscal_year))
  }

  const fetchFunds = (_filters) => {
    return api.get('/report-funds', {
      params: { ..._filters }
    })
  }

  const fetchFiscalYears = () => {
    return api.get('company-rules/fiscal-years');
  }

  const exportData = async () => {
    setIsExport(true)
    const format = (table, fileName) => {
      return (`
      <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel">
        <head>
          <!--[if gte mso 9]>
            <xml>
              <x:ExcelWorkbook>
                  <x:ExcelWorksheets>
                    <x:ExcelWorksheet>
                        <x:Name>${fileName || 'Worksheet'}</x:Name>
                        <x:WorksheetOptions>
                          <x:DisplayGridlines/>
                        </x:WorksheetOptions>
                    </x:ExcelWorksheet>
                  </x:ExcelWorksheets>
              </x:ExcelWorkbook>
            </xml>
          <![endif]-->
          <meta http-equiv="content-type" content="text/plain; charset=UTF-8"/>
        </head>
        <body>
          ${convertToAscii(ReactDOMServer.renderToString(table), [160])}
        </body>
      </html>`
      )
    }

    const buildTable = data => {
      return (
        <Table>
          <thead>
            {columns.map((col, i) => (
              <th key={i}>{col.text}</th>
            ))}
          </thead>
          <tbody>
            {data.map(d => {
              return (
                <tr>
                  {columns.map((col, i) => {
                    return (
                      <td key={i}>{d[col.dataField]}</td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
      )
    }

    var _filters = {...filters}

    delete _filters.per_page
    delete _filters.page

    const response = await fetchFunds(_filters)
    const { data } = response.data

    let table_div = format(buildTable(formatData(data)), "report_funds")
    var a = document.createElement('a')
    var data_type = 'data:application/vnd.ms-excel; charset=UTF-8'
    var table_html = escape(table_div)
    a.href = data_type + ', ' + table_html
    a.download = 'report_invoices.xls'
    a.click();
    setIsExport(false)
  }

  const formatData = data => {
    const formatValue = value => {
      var val = value ?? 0;
      return val.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      });
    }

    return data.map(({ manufacturer, real_value, period, action_id, action_name, action_value, balance }, idx) => ({
      index: idx,
      manufacturer,
      period,
      action_name: action_name ?? "--",
      action_id: action_id ?? "--",
      action_value: formatValue(action_value),
      real_value: formatValue(parseFloat(real_value)),
      balance: formatValue(balance)
    }))
  }

  return (
    <Card.Body className="shadow bg-white rounded mb-3">
      <Row>
        <Col className="d-flex mt-3 mb-3">
          <DashboardOutlined className="icon-title" />
          <h4 className="title-dashboard mt-2">Relatório de Verbas</h4>
        </Col>
        <Col md="12" className="mb-2">
          <Button
            onClick={() => exportData()}
            disabled={isExport}
          >
            Exportar Tabela
            {' '}
            <Spinner
              animation="border"
              role="status"
              size="sm"
              style={!isExport ? { display: 'none' } : {}}
            />
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Row>
            <Col>
              <ListingReportsFunds
                data={funds}
                filters={[]}
                pagination={pagination}
                stateFilters={setFilters}
                handleFilterChange={handleFilterChange}
                load={load}
                fiscalYears={fiscalYears}
                columns={columns}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Card.Body>
  )
}

export default MasterPage(ReportFunds)